// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card_wrapper_3ERRx","cheater":"card_cheater_1EGVV","top":"card_top_3bOJD","title":"card_title_2xqBX"};